interface PostFeedbackProps {
  supportNotice: boolean;
  isHeld: boolean;
}

/**
 * Shown right after a topic or comment is submitted. The two notices are
 * independent — see ModerationService.classify — so either, both, or
 * neither can apply to the same post.
 */
export function PostFeedback({ supportNotice, isHeld }: PostFeedbackProps): React.JSX.Element | null {
  if (!supportNotice && !isHeld) {
    return null;
  }

  return (
    <>
      {supportNotice && (
        <p className="notice" data-testid="support-notice">
          This forum is intended for discussion and feedback rather than support requests. For
          system issues or urgent assistance, please contact{' '}
          <a href="mailto:csc@betterhome.co.za">csc@betterhome.co.za</a>.
        </p>
      )}
      {isHeld && (
        <p className="notice warning" data-testid="held-notice">
          Your post is being held for moderator review before it is visible to others. You can
          still see it here.
        </p>
      )}
    </>
  );
}
